export default __webpack_public_path__ + "static/media/download.cc2bf244.svg";